import React from 'react';
import {executeBackendQuery} from './requests/executeBackendQuery';
import {VENDOR_TYPES} from './consts/queries';

let request = null;

/** [{NAME, SUBTYPES: [name, ...]}, ...] from the VENDOR_TYPES / VENDOR_SUBTYPES tables. */
export function fetchVendorTypes() {
    if (!request) {
        request = executeBackendQuery({queryName: VENDOR_TYPES, params: {}})
            .then((res) => {
                if (res && res.success && Array.isArray(res.data)) return res.data;
                request = null;
                return [];
            })
            .catch(() => {
                request = null;
                return [];
            });
    }
    return request;
}

export function useVendorTypes() {
    const [types, setTypes] = React.useState([]);

    React.useEffect(() => {
        let live = true;
        fetchVendorTypes().then((loaded) => {
            if (live) setTypes(loaded);
        });
        return () => {
            live = false;
        };
    }, []);

    return types;
}

export function subtypesOf(types, typeName) {
    const type = (types || []).find((t) => t.NAME === typeName);
    return type && Array.isArray(type.SUBTYPES) ? type.SUBTYPES : [];
}
